import { render, staticRenderFns } from "./swtich.vue?vue&type=template&id=2ee5f6f0&scoped=true"
import script from "./swtich.vue?vue&type=script&lang=js"
export * from "./swtich.vue?vue&type=script&lang=js"
import style0 from "./swtich.vue?vue&type=style&index=0&id=2ee5f6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5f6f0",
  null
  
)

export default component.exports